import { Grid } from '@mui/material'
import clsx from 'clsx'
import Image, { StaticImageData } from 'next/image'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSlug from 'rehype-slug'
import useStyles from './Style'

interface IProps {
  zenMode: boolean
  color?: boolean
  content: {
    bg: StaticImageData
    icon?: string
    heading?: string
    text?: string
  }
}
const HeaderCard: React.FC<IProps> = ({ zenMode, content, color }) => {
  const { icon, heading, text, bg } = content
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rehypeRawDec:any = rehypeRaw
  const { classes } = useStyles()
  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenRootContainer
      )}
      sx={{
        backgroundImage: `url(${bg?.src})`,
      }}
    >
      {icon && heading && text ? (
        <Grid
          container
          className={classes.contentContainer}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            className={classes.iconContainer}
            md={12}
            sm={12}
            xs={12}
            sx={{
              display: zenMode ? 'none' : 'flex',
              justifyContent: 'center',
            }}
          >
            <Image alt={heading} src={icon} width={142} height={142} />
          </Grid>

          <Grid
            className={classes.heading}
            sx={{ color: color && !zenMode ? 'white' : 'black' }}
          >
            {heading}
          </Grid>
          <Grid
            className={classes.text}
            sx={{ color: color && !zenMode ? 'white' : 'black' }}
          >
            <ReactMarkdown rehypePlugins={[rehypeRawDec,rehypeSlug]}>{text}</ReactMarkdown>
          </Grid>
        </Grid>
      ) : (
        ''
      )}
    </Grid>
  )
}

export default HeaderCard
